module.exports = __webpack_public_path__ + "img/tokenizer_big.d6362327.svg";